<style scoped>
    .flip-right{
        transform: translateX(0px) translateY(65px) translateZ(0px) rotateX(0deg) rotateY(50deg) rotateZ(0deg) scaleX(1) scaleY(1) skewX(0deg) skewY(0deg);
        transition-duration: 1200ms;
        transform-origin: 50% 50%;
        transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000) !important;
        transition-delay: 150ms;
        opacity: 0;
    }

    .flip-right.active{
        transform: none;
        opacity: 1;
    }

    .perspective {
        perspective: 1000px;
    }

    .fade-up {
        opacity: 0;
        transform: translateY(20px);
        transition: opacity 1s ease, transform 1s ease;
    }

    .fade-up.active {
        opacity: 1;
        transform: none;
    }

    .fade-up {
        animation: fadeUp 1s ease-in forwards;
        opacity: 0;
    }

    .fade-up.active {
        opacity: 1;
    }
</style>

<template>
    <layout-general-container>
        <div class="h-screen grid grid-cols-5 relative items-center">
            <div class="h-screen bg-about-banner brightness-50 col-span-5"></div>
            <div class="absolute w-full grid grid-cols-3 bottom-32 perspective">
                <div class="col-span-3 md:col-span-2 flex flex-col px-12 md:px-20 flip-right animate">
                    <h1 class="lg:text-4xl lg:leading-snug leading-snug text-2xl font-semibold text-white">
                        Our vision is to create a world where businesses <span class="text-accent">operate responsibly</span>, motivated by <span class="text-accent">purpose and positive impact</span>
                    </h1>
                </div>
            </div>
        </div>
        <div class="h-[28rem] lg:h-[20rem] bg-primary md:px-10 px-6 text-white items-center justify-center flex-col flex text-center gap-4 perspective">
            <span class="text-sm md:text-base leading-relaxed md:leading-loose flip-right animate">
                We understand that the journey of a social enterprise is filled with obstacles–from securing funding to finding the right mentors. That’s why we offer tailored funding opportunities, expert mentorship, and dynamic growth programs designed to support you at every stage of your journey–whether you're just starting out or scaling your business.
                <br/>
                <br/>
                Our purpose for fostering innovation within the social entrepreneurship ecosystem drives us to create a platform where knowledge meets opportunity. We believe by equipping you with the right support, we can help you achieve the impact you’re aiming for.
                <br/>
                <br/>
                At Instellar Integrated Platform, you can unlock your social enterprise’s potential and make a difference in the world.
            </span>
        </div>

        
        <div class="relative md:py-16 py-8 px-2">
            <div class="w-full text-center lg:px-24 md:px-12 md:pb-16 pb-8">
                <h2 class="text-xl md:text-4xl text-primary font-semibold mb-4">Look back on Instellar’s impactful journey and celebrate the milestones we’ve achieved in growing social enterprises.</h2>
            </div>

            <div 
                v-for="(items, year, index) in milestones" :key="year" 
            >
                <div class="max-w-7xl mx-auto w-full grid grid-cols-9"
                    :class="{ 'md:-mt-16': index > 0 }"
                >
                    <div
                        class="col-span-8 md:col-span-4 w-full h-full relative order-2 pb-8 md:pb-0"
                        :class="{ 'md:order-1 md:text-end': index % 2 === 0, 'md:order-3': index % 2 !== 0}"
                    >
                        <h2 class="text-primary text-4xl font-bold mb-8 border-b-2 border-dashed inline-block border-primary">{{ year }}</h2>

                        <div v-for="(item, lItem) in items" 
                            :key="item" 
                            class="flex md:gap-8 gap-4 flex-col-reverse lg:flex-row fade-up animate" 
                            :class="{ 'border-t-2 border-solid mt-6 pt-6': lItem > 0, 'lg:flex-row-reverse lg:items-center': index % 2 !== 0, 'md:items-end': index % 2 === 0 }"
                        >
                            <p class="text-light sm:text-sm text-xs md:text-base leading-loose">
                                {{ item.description }}
                            </p>
                            
                            <img :src="item.image" alt="Milestone image" class="max-w-[12.5rem] lg:max-h-[12.5rem] md:max-w-auto" v-if="item.image" />
                        </div>
                    </div>

                    <div class="relative h-full col-span-1 w-full flex justify-center md:order-2">
                        <div class="absolute w-1 bg-primary h-full"></div>
                        <div class="absolute w-6 h-6 rounded-full bg-primary z-[5px] text-white text-center flex items-center justify-center">
                            <span class="w-4 h-4 bg-white rounded-full"></span>
                        </div>
                    </div>

                    <div
                        class="col-auto md:col-span-4 w-full h-full hidden md:block"
                        :class="{ 'order-3': index % 2 === 0, 'order-1': index % 2 !== 0 }"
                    >
                    </div>
                </div>
            </div>
            
            <div class="max-w-7xl mx-auto w-full grid grid-cols-9">
                <div class="relative h-full md:col-span-9 col-span-1 w-full flex justify-center items-end">
                    <div class="absolute w-6 h-6 rounded-full bg-primary z-[5px] text-white text-center flex items-center justify-center">
                        <span class="w-4 h-4 bg-white rounded-full"></span>
                    </div>
                </div>

                <div class="col-span-9 w-full h-full text-center mt-4">
                    <h2 class="text-primary text-4xl font-bold border-b-2 border-dashed inline-block border-primary">Now</h2>

                    <div class="image gap-8 flex flex-wrap justify-center my-8 fade-up animate">
                        <img :src="img" alt="Milestone image" class="max-h-[12.5rem]" v-for="(img, index) in milestonesNowImages" :key="index" />
                    </div>
                    
                    <p class="text-light text-2xs leading-loose text-center font-bold fade-up animate">
                        We keep on striving to create the change that the world wants to see.
                    </p>
                </div>
            </div>
        </div>

        <!-- <div class="w-full px-6 md:px-8 xl:px-14 flex-col flex gap-8 bg-white py-14 md:py-24">
            <span class="text-3xl md:text-4xl text-primary tracking-wide font-semibold">Meet the dedicated team behind Instellar, whose diverse expertise and years of experience drive our mission to grow social enterprises and create meaningful impact.</span>
            <div class="grid w-full grid-cols-2 xl:grid-cols-4 gap-6 md:gap-8 xl:gap-12">
                <div v-for="item in teams" :key="item.name" class="flex flex-col gap-3">
                    <div class="h-[15rem] relative">
                        <div class="absolute bg-black opacity-20 h-[15rem] w-full"></div>
                        <img :src="item.image" class="w-full rounded-md object-cover h-[15rem]"
                            alt="">
                    </div>
                    <div class="flex flex-row w-full justify-between">
                        <div class="flex flex-col gap-1">
                            <span class="text-base font-semibol text-primary">{{ item.name }}</span>
                            <span class="text-sm text-light">{{ item.role }}</span>
                        </div>
                        <div @click="goTo(item.url)" class="p-1">
                            <IconArrowUpRight class="cursor-pointer hover:text-primary" :size="22" />
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </layout-general-container>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { IconArrowUpRight } from "@tabler/icons-vue"
import Milestones1 from "@/assets/img/ILUSTRASI-2014.png";
import Milestones2_1 from "@/assets/img/ILUSTRASI-2017-1.png";
import Milestones2_2 from "@/assets/img/ILUSTRASI-2017-2.png";
import Milestones3_1 from "@/assets/img/ILUSTRASI-2018-1.png";
import Milestones3_2 from "@/assets/img/ILUSTRASI-2018-2.png";
import Milestones4 from "@/assets/img/ILUSTRASI-2019.png";
import Milestones5_1 from "@/assets/img/B-Corp-Logo-B-min.png";
import Milestones5_2 from "@/assets/img/Zebra-Head-2-min.png";

import MilestonesNow_1 from "@/assets/img/about-now/impactful.png";
import MilestonesNow_2 from "@/assets/img/about-now/entrepreneurial.png";
import MilestonesNow_3 from "@/assets/img/about-now/collaboration.png";
import MilestonesNow_4 from "@/assets/img/about-now/fair.png";
import MilestonesNow_5 from "@/assets/img/about-now/cool.png";

import Team1 from '@/assets/img/team/1.jpg'
import Team2 from '@/assets/img/team/2.jpg'
import Team3 from '@/assets/img/team/3.jpg'
import Team4 from '@/assets/img/team/4.jpg'
import Team5 from '@/assets/img/team/5.jpg'
import Team6 from '@/assets/img/team/6.jpg'
import Team7 from '@/assets/img/team/7.jpg'
import Team8 from '@/assets/img/team/8.jpg'
import Team9 from '@/assets/img/team/9.jpg'
import Team10 from '@/assets/img/team/10.jpg'

const milestonesNowImages = ref({
  impactful: MilestonesNow_1,
  entrepreneurial: MilestonesNow_2,
  collaboration: MilestonesNow_3,
  fair: MilestonesNow_4,
  cool: MilestonesNow_5,
})

const milestones = ref({
    2014: [
        {
            image: Milestones1,
            description: "Instellar started as UnLtd. Indonesia and launched Rise Inc., an incubation program for social enterprises.",
        }
    ],
    2017: [
        {
            image: Milestones2_1,
            description: "The company rebranded to Instellar, reflecting its belief in the potential of every individual.",
        },
        {
            image: Milestones2_2,
            description: "Instellar hosted ARISE, an event to showcase Rise Inc. graduates and connect them with key stakeholders in the impact ecosystem.",
        }
    ],
    2018: [
        {
            image: Milestones3_1,
            description: "Instellar partnered with its first corporate client to organize a co-creation program for social entrepreneurs, expanding the impact ecosystem.",
        },
        {
            image: Milestones3_2,
            description: "Instellar launched Impact Advisory to assist social enterprises and NGOs in reaching investment readiness.",
        },
    ],
    2019: [
        {
            image: Milestones4,
            description: "Instellar grew its impact ecosystem with diverse programs and reached a significant milestone of 100 social enterprise graduates.",
        }
    ],
    2023: [
        {
            image: Milestones5_1,
            description: "Instellar achieved B Corp certification, first and only B Corp certified impact advisory in Indonesia.",
        },
        {
            image: Milestones5_2,
            description: "Launching Instellar Investment to provide innovative financing instruments for Zebra companies.",
        }
    ]
});

const teams = ref([
    {
        name: 'Romy Cahyadi',
        image: Team1,
        role: 'Chief Executive Officer',
        url: 'https://www.linkedin.com/in/romy-cahyadi-80237a1a/'
    },
    {
        name: 'Adisti Chandra',
        image: Team2,
        role: 'Chief Operating Officer',
        url: 'https://www.linkedin.com/in/adisti-chandra-a94b4a38/'
    },
    {
        name: 'Dewi Ayuningtyas',
        image: Team3,
        role: 'Chief Financial Officer',
        url: 'https://www.linkedin.com/in/dewi-ayuningtyas-485743b5/'
    },
    {
        name: 'Stephanie Hermawan',
        image: Team4,
        role: 'Managing Partner Invesment',
        url: 'https://www.linkedin.com/in/stephanie-hermawan-1260892ab'
    },
    {
        name: 'Irvan Faried',
        image: Team5,
        role: 'Head of Impact Advisory',
        url: 'https://www.linkedin.com/in/irvanfaried/'
    },
    {
        name: 'M. Bima Luphdika',
        image: Team6,
        role: 'Impact Advisory Lead',
        url: 'https://www.linkedin.com/in/muhammad-bima-luphdika-bb793a128/'
    },
    {
        name: 'Aulia Dewi',
        image: Team7,
        role: 'Impact Advisory Officer',
        url: 'https://id.linkedin.com/in/auliadewi'
    },
    {
        name: 'Anugrah Rizky',
        image: Team8,
        role: 'Head of Enterprise Development',
        url: 'https://www.linkedin.com/in/anugrahrizkyh'
    }
])

const goTo = (url) => {
    window.open(url, '_blank')
}

onMounted(() => {
    setTimeout(() => {
        const sections = document.querySelectorAll('.animate');

        const observer = new IntersectionObserver((entries) => 
            {
                entries.forEach((entry) => 
                    {
                        if (entry.isIntersecting) {
                            entry.target.classList.add('active');
                        }
                    });
            },
            { threshold: 0.3 }
        );
    
        sections.forEach((section) => {
            observer.observe(section);
        });
    }, 500);

});
</script>
